export { ActivityMonitorModule } from './activity-monitor.module';
export { ActivityMonitorComponent } from './container/activity-monitor.component';
export { ActivityMonitorConfig, ACTIVITY_MONITOR_CONFIG } from '@backbase/identity-auth';
